# 资源详情页面右侧的操作

$ ->
  $(document)
  .on 'click', '.detail-action-move .detail-action, .detail-action-copy .detail-action, .detail-action-copy-todo .detail-action', (e) ->
    e.preventDefault()

    $target = $(e.target)
    $confirm = $target.next('.confirm')
    $wrap = $confirm.closest('.item')

    $('.detail-actions .item.expanded').removeClass('expanded')

    $wrap.addClass('expanded')
      .one simple.util.transitionEnd(), (e) ->
        $wrap.css('overflow', 'visible')

    return  unless $confirm.find('.choose-projects').hasClass 'loading'

    if $target.hasClass 'detail-action-todo'
      initSelectProj($confirm, true)
      initSelectList($confirm)
    else if $wrap.hasClass 'detail-action-copy'
      initSelectProj($confirm, true)
    else
      initSelectProj($confirm, false)

  .on 'click', '.detail-actions .confirm .cancel', (e) ->
    e.preventDefault()
    $(e.target).closest('.item')
      .attr('style', '')
      .removeClass('expanded')

  .on 'ajax:beforeSend', '.detail-actions .confirm .form', (e, xhr, settings) ->
    $form = $(@)
    $input = $form.find('.select-choose-projects input:last')
    isKanban = $form.find('.select-choose-projects').data('select')?.selectItem()?.is_kanban
    valid = true

    if !$input.val()
      $form.find('.select-result:first').addClass 'error'
      valid = false
    else if $form.find('.select-choose-todolists').length and isKanban
      if !$form.find('input[name=tluid]').val()
        $form.find('.select-result:last').addClass 'error'
        valid = false

    unless valid
      $btn = $form.find('button[type=submit]')
      $btn.text $btn.data('ujs:enableWith')
        .prop 'disabled', false
        .trigger('blur')
      return false

    $form.find('.cancel').hide()

  .on 'ajax:complete', '.detail-actions .confirm .form', ->
    $(@).find('.cancel').show()

  .on 'ajax:success', '.detail-actions .confirm .form', (e, result) ->
    return unless result.success

    $form = $(@)

    $todolist = $(".todolist[data-guid='#{result.todolist_guid}']")

    classList = e.currentTarget.classList
    if classList.contains('form-copy')
      action = '复制'
    else if classList.contains('form-move')
      action = '移动'

    if $todolist.length
      successTpl = """
        <div class="page-tip action hide">
            #{action}完成
        </div>
      """
    else
      successTpl = """
        <div class="page-tip action hide">
            #{action}完成，这个条目已被#{action}到 <em>{{ proj_name | encodeHtml }}</em> 中，
            <a data-nocache data-stack data-stack-root
                #{ result.proj_kanban || 'data-parent-name="{{ proj_name | encodeHtml }}"' }
                #{ result.proj_kanban || 'data-parent-url="{{ proj_url }}"' }
                href="{{ url }}">现在就去查看 →</a>
        </div>
      """
    $actions = $form.closest('.detail-actions')
    inPage = $actions.closest('.tr-page').length
    inTrTodoPage = $form.closest('tr-todo-page').length
    if inPage
      $wrapper = $actions.closest('.page__content')
    else if inTrTodoPage
      $wrapper = $form.closest('tr-todo-page').find('.todo-page-main')
    else
      $wrapper = $actions.closest('.page-inner')

    $mask = $('<div class="mask hide"></div>')
    $tip = $ simple.tpl(successTpl, result)

    if $todolist.length
      $tip.appendTo($wrapper).slideDown()
      setTimeout ->
        $tip.slideUp()
      , 3000
      $actions.find('.btn-x').click()
    else
      $mask.appendTo($wrapper).fadeIn ->
        $tip.prependTo($wrapper).slideDown()

    if $form.hasClass('form-move')
      tower.todoSubject.next('move', {
        id: result.todo_id,
        todolistGuid: result.todolist_guid,
        todolistName: result.todolist_name,
        rowData: result.rowData,
      });

  .on 'ajax:success', '.detail-action-star', (e) ->
    e.preventDefault()

    $target = $(e.target)

    if $target.hasClass 'stared'
      $target.removeClass('stared').text('收藏')
    else
      $target.addClass('stared').text('取消收藏')


initSelectProj = ($confirm, showCurrentProj) ->
  $select = $confirm.find('.choose-projects')

  selectProj = simple.select
    el: $select
    placeholder: '点击选择项目'
    cls: 'select-choose-projects'

  selectProj.on 'select', (e, item) ->
    $confirm.find('input[type=hidden]').first().val item.guid
  .on 'keydown', (e) ->
    if e.which is 13 and !selectProj.input.hasClass('expanded')
      $confirm.find('.form').trigger('submit')
      return false
  .on 'clear', ->
    $confirm.find('.select-choose-projects input:last').val('')

  $.ajax
    url: "/members/#{ tower.me.guid }/projects.json/"
    type: 'get'
    dataType: 'json'
    success: (result) ->
      projGuid = $select.data('project')
      items = []
      selectedItem = null
      $.each result, (i, proj) ->
        item =
          label: proj.name
          guid: proj.guid
          key: "#{proj.name} #{proj.name_pinyin} #{proj.name_pinyin_abbr}"
          is_kanban: proj.project_type is 1
        selectedItem = item  if projGuid is item.guid
        items.push item  if showCurrentProj or (projGuid isnt item.guid)

      $select.removeClass('loading')
      if items.length is 0
        selectProj.disable()
        selectProj.input.val '没有可选项目...'
        return

      selectProj.setItems items
      selectProj.selectItem $.inArray(selectedItem, items)
      $confirm.find('button[type=submit]').prop 'disabled', false


initSelectList = ($confirm) ->
  selectList = simple.select
    el: $confirm.find('.choose-todolists')
    placeholder: '不选择任何清单'
    cls: 'select-choose-todolists'

  selectList.on 'select', (e, item) ->
    $confirm.find('input[name=tluid]').val item.guid
  .on 'keydown', (e) ->
    if e.which is 13 and !selectList.input.hasClass('expanded')
      $confirm.find('.form').trigger('submit')
      return false
  .on 'clear', ->
    $confirm.find('input[name=tluid]').val('')

  selectProj = $confirm.find('.select-choose-projects').data 'select'
  selectProj.on 'select', (e, item) ->
    selectList.enable()
    selectList.clearSelection()

    $.ajax
      url: "/projects/#{item.guid}/lists/uncompleted/"
      type: 'get'
      dataType: 'json'
      success: (result) ->
        if result.length
          selectList.setItems result
          selectList.select.show()
          selectList.selectItem(0)  if item.is_kanban
  .on 'clear', ->
    selectList.select.hide()
    selectList.clearSelection()


$.extend tower,
  initSelectList: ($confirm) ->
    selectList = simple.select
      el: $confirm.find('.choose-todolists')
      placeholder: '不选择任何清单'
      cls: 'select-choose-todolists'

    selectList.on 'select', (e, item) ->
      $confirm.find('input[name=tluid]').val item.guid
    .on 'keydown', (e) ->
      if e.which is 13 and !selectList.input.hasClass('expanded')
        $confirm.find('.form').trigger('submit')
        return false
    .on 'clear', ->
      $confirm.find('input[name=tluid]').val('')

    selectProj = $confirm.find('.select-choose-projects').data 'select'
    selectProj.on 'select', (e, item) ->
      selectList.enable()
      selectList.clearSelection()

      $.ajax
        url: "/projects/#{item.guid}/lists/uncompleted/"
        type: 'get'
        dataType: 'json'
        success: (result) ->
          if result.length
            selectList.setItems result
            selectList.select.show()
            selectList.selectItem(0)  if item.is_kanban
    .on 'clear', ->
      selectList.select.hide()
      selectList.clearSelection()

  initSelectProj: ($confirm, showCurrentProj) ->
    $select = $confirm.find('.choose-projects')

    selectProj = simple.select
      el: $select
      placeholder: '点击选择项目'
      cls: 'select-choose-projects'

    selectProj.on 'select', (e, item) ->
      $confirm.find('input[type=hidden]').first().val item.guid
    .on 'keydown', (e) ->
      if e.which is 13 and !selectProj.input.hasClass('expanded')
        $confirm.find('.form').trigger('submit')
        return false
    .on 'clear', ->
      $confirm.find('.select-choose-projects input:last').val('')

    $.ajax
      url: "/members/#{ tower.me.guid }/projects.json/"
      type: 'get'
      dataType: 'json'
      success: (result) ->
        projGuid = $select.data('project')
        items = []
        selectedItem = null
        $.each result, (i, proj) ->
          item =
            label: proj.name
            guid: proj.guid
            key: "#{proj.name} #{proj.name_pinyin} #{proj.name_pinyin_abbr}"
            is_kanban: proj.project_type is 1
          selectedItem = item  if projGuid is item.guid
          items.push item  if showCurrentProj or (projGuid isnt item.guid)

        $select.removeClass('loading')
        if items.length is 0
          selectProj.disable()
          selectProj.input.val '没有可选项目...'
          return

        selectProj.setItems items
        selectProj.selectItem $.inArray(selectedItem, items)
        $confirm.find('button[type=submit]').prop 'disabled', false
